export const formatAmount = (amount, decimals = 2) => {
  try {
    if (amount === null || amount === undefined) return (0).toFixed(decimals);
    let num;
    if (typeof amount === "object") {
      num = Number(amount.balance);
    } else {
      num = Number(amount);
    }
    if (isNaN(num)) return (0).toFixed(decimals);
    const truncated = Math.floor(num * 10 ** decimals) / 10 ** decimals;
    return truncated.toFixed(decimals);
  } catch (err) {
    return (0).toFixed(decimals);
  }
};


// export const formatAmount = (amount, decimals = 2) => {
//   try {
//     let num = 0;

//     if (amount === null || amount === undefined) {
//       return num.toFixed(decimals);
//     }

//     if (typeof amount === "object") {
//       num = Number(amount.balance ?? 0);
//     } else {
//       num = Number(amount);
//     }

//     if (isNaN(num)) {
//       return (0).toFixed(decimals);
//     }

//     // ✅ Force only 2 digits after decimal (truncate, not round)
//     return (Math.floor(num * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
//   } catch (err) {
//     return (0).toFixed(decimals);
//   }
// };
